"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCircuitBreakerHashFromModel = exports.defaultModelAssertStatusCode = exports.defaultAssertStatusCode = exports.defaultCircuitBreakerHash = void 0;
var defaultCircuitBreakerHash = function (requestConfig) {
    return [requestConfig.method, requestConfig.url.hostname, requestConfig.url.pathname].join(':');
};
exports.defaultCircuitBreakerHash = defaultCircuitBreakerHash;
var defaultCircuitBreakerHashFromModel = function (model) {
    return "".concat(model.method, ":").concat(model.microserviceName, ":").concat(model.pathApi);
};
exports.defaultCircuitBreakerHashFromModel = defaultCircuitBreakerHashFromModel;
var defaultAssertStatusCode = function (statusCode) { return statusCode >= 200 && statusCode < 400; };
exports.defaultAssertStatusCode = defaultAssertStatusCode;
var defaultModelAssertStatusCode = function (assertStatusCodes) { return function (statusCode) {
    return assertStatusCodes.includes(statusCode);
}; };
exports.defaultModelAssertStatusCode = defaultModelAssertStatusCode;
//# sourceMappingURL=defaultSettings.js.map